import React, { useContext } from "react";
import Styles from "./Located.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import A from "@vahak/core/dist/components/app-anchor/A";
import AppBtn from "@vahak/core/dist/components/app-btn/AppBtn";
import { COMPANY_DETAILS } from "@vahak/core/dist/constants/companyDetails";

const Located = () => {
    const { isMobile } = useContext(AppContext);

    return (
        <>
            <div className={Styles.heading}>
                <h2>
                    We’re located at the{" "}
                    <span data-hover="heart of Bangalore" className={isMobile ? "" : "indaiText"}>
                        heart of Bangalore
                    </span>
                </h2>
            </div>
            <div className={Styles.locatedRow}>
                <div className={Styles.locatedMapCol}>
                    <iframe
                        src={COMPANY_DETAILS.googleMapEmbedLink}
                        width="460"
                        style={{
                            border: "0px",
                            width: "100%",
                            borderRadius: "15px",
                            height: isMobile ? "200px" : "415px"
                        }}
                        loading="lazy"
                        title="Vahak Office Map"
                    ></iframe>
                </div>
                <div className={Styles.locatedAddressCol}>
                    <div className={Styles.addressBox}>
                        <div className={Styles.row}>
                            <div className={Styles.col}>
                                <h4>{COMPANY_DETAILS.workspace}</h4>
                            </div>
                            <div className={Styles.col}>
                                <p>{COMPANY_DETAILS.address}</p>
                            </div>
                        </div>
                        <A openInNewTab href={COMPANY_DETAILS.googleMapLink}>
                            <AppBtn className={Styles.viewMapButton}>View on Maps</AppBtn>
                        </A>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Located;
